//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./chat_session.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// enum ChatRole
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class ChatRole extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum ChatTitleStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class ChatTitleStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct ChatToolCall
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ChatToolCall.Mutable`. */
export class ChatToolCall extends $._FrozenBase {}

function initChatToolCall(target, initializer) {
  target.name = initializer.name ?? "";
  target.argumentsJson = initializer.argumentsJson ?? "";
}

// -----------------------------------------------------------------------------
// struct ChatMessage
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ChatMessage.Mutable`. */
export class ChatMessage extends $._FrozenBase {}

function initChatMessage(target, initializer) {
  target.id = initializer.id ?? "";
  target.sessionId = initializer.sessionId ?? "";
  target.role = ChatRole.create(initializer.role ?? ChatRole.UNKNOWN);
  target.content = initializer.content ?? "";
  target.toolCalls = $._toFrozenArray(
    initializer.toolCalls || [],
    ChatToolCall.create,
  );
  target.sequence = initializer.sequence ?? 0;
  target.createdAt = initializer.createdAt ?? $.Timestamp.UNIX_EPOCH;
}

// -----------------------------------------------------------------------------
// struct ChatSession
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ChatSession.Mutable`. */
export class ChatSession extends $._FrozenBase {}

function initChatSession(target, initializer) {
  target.id = initializer.id ?? "";
  target.userId = initializer.userId ?? "";
  target.accountId = initializer.accountId ?? BigInt(0);
  target.title = initializer.title ?? "";
  target.titleStatus = ChatTitleStatus.create(initializer.titleStatus ?? ChatTitleStatus.UNKNOWN);
  target.createdAt = initializer.createdAt ?? $.Timestamp.UNIX_EPOCH;
  target.updatedAt = initializer.updatedAt ?? $.Timestamp.UNIX_EPOCH;
  target.lastMessageAt = initializer.lastMessageAt ?? $.Timestamp.UNIX_EPOCH;
  target.messageCount = initializer.messageCount ?? 0;
  target.preview = initializer.preview ?? "";
}

// -----------------------------------------------------------------------------
// struct ChatSessionSearchHit
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ChatSessionSearchHit.Mutable`. */
export class ChatSessionSearchHit extends $._FrozenBase {}

function initChatSessionSearchHit(target, initializer) {
  target.session = ChatSession.create(initializer.session ?? ChatSession.DEFAULT);
  target.snippet = initializer.snippet ?? "";
  target.score = initializer.score ?? 0;
  target.matchingMessageId = initializer.matchingMessageId ?? "";
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "chat_session.skir",
  [
    {
      kind: "enum",
      ctor: ChatRole,
      name: "ChatRole",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "USER",
          number: 1,
        },
        {
          name: "ASSISTANT",
          number: 2,
        },
      ],
    },
    {
      kind: "enum",
      ctor: ChatTitleStatus,
      name: "ChatTitleStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "PENDING",
          number: 1,
        },
        {
          name: "GENERATED",
          number: 2,
        },
        {
          name: "MANUAL",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: ChatToolCall,
      initFn: initChatToolCall,
      name: "ChatToolCall",
      fields: [
        {
          name: "name",
          property: "name",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "arguments_json",
          property: "argumentsJson",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ChatMessage,
      initFn: initChatMessage,
      name: "ChatMessage",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "session_id",
          property: "sessionId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "role",
          property: "role",
          number: 2,
          type: {
            kind: "record",
            ctor: ChatRole,
          },
        },
        {
          name: "content",
          property: "content",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "tool_calls",
          property: "toolCalls",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ChatToolCall,
            },
          },
          mutableGetter: "mutableToolCalls",
        },
        {
          name: "sequence",
          property: "sequence",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "created_at",
          property: "createdAt",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ChatSession,
      initFn: initChatSession,
      name: "ChatSession",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "user_id",
          property: "userId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "title",
          property: "title",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "title_status",
          property: "titleStatus",
          number: 4,
          type: {
            kind: "record",
            ctor: ChatTitleStatus,
          },
        },
        {
          name: "created_at",
          property: "createdAt",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "updated_at",
          property: "updatedAt",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "last_message_at",
          property: "lastMessageAt",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "message_count",
          property: "messageCount",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "preview",
          property: "preview",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ChatSessionSearchHit,
      initFn: initChatSessionSearchHit,
      name: "ChatSessionSearchHit",
      fields: [
        {
          name: "session",
          property: "session",
          number: 0,
          type: {
            kind: "record",
            ctor: ChatSession,
          },
          mutableGetter: "mutableSession",
        },
        {
          name: "snippet",
          property: "snippet",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "score",
          property: "score",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "float32",
          },
        },
        {
          name: "matching_message_id",
          property: "matchingMessageId",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
  ]
);
